import styled from 'styled-components';
import { Section, InnerSection } from '../../../../styles/section/section';

export const StyledSection = styled(Section)`
  padding-top: 0;
  min-height: auto;

  /* 
    HACK: This media query is needed because the underlying styled section 
    overrides the padding-top with a media query of its own.
  */

  @media (min-width: ${props => props.theme.breakpoint.md}px) {
    padding-top: 0;
  }
`;

export const StyledSectionInner = styled(InnerSection)`
  padding-top: 1.5rem;
  padding-bottom: 2rem;
`;

export const StyledResultsList = styled.ul`
  margin-bottom: 2.5rem;
  padding: 0;
`;
